class EventBusWithPromise {
  constructor() {
    this.events = {};
    this.waitingComponents = new Map(); // 等待组件加载的 Promise
  }

  // 注册组件等待
  waitForComponent(componentName) {
    if (!this.waitingComponents.has(componentName)) {
      let resolve;
      const promise = new Promise((res) => {
        resolve = res;
      });
      this.waitingComponents.set(componentName, { promise, resolve });
    }
    return this.waitingComponents.get(componentName).promise;
  }

  // 组件就绪
  componentReady(componentName) {
    if (this.waitingComponents.has(componentName)) {
      this.waitingComponents.get(componentName).resolve();
      this.waitingComponents.delete(componentName);
    }
  }

  $on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    console.log('$on');
  }

  async $emit(event, data, options = {}) {
    const { waitFor } = options;

    if (waitFor) {
      // 等待指定组件加载完成
      await this.waitForComponent(waitFor);
    }

    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        callback(data);
      });
    }
    console.log(this.events, 'this.events');
  }

  $off(event, callback) {
    if (this.events[event]) {
      if (callback) {
        this.events[event] = this.events[event].filter((cb) => cb !== callback);
      } else {
        delete this.events[event];
      }
    }
  }
}

export default new EventBusWithPromise();
